async function devtricker_ajax_post_customWpLogin(form) {
    try {

        sessionStorage.clear();

        const formData = new FormData(form);

        formData.append('action', 'devtricker_account_login_email_action_perform_login_ajax');
        formData.append('login_nonce', await devtricker_ajax_get_devtricker_getDevtrickerLoginNonce());

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {

            devtricker_log(null, devtricker_log_level.INFO, "Login successful");

            return result.data.user_id;

        } else {
            throw new Error('Incorrect email or password');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function devtricker_ajax_post_customWpLoginPow(form, pow, pass, duration) {
    try {

        sessionStorage.clear();
        
        const formData = new FormData(form);

        formData.append('action', 'devtricker_account_login_email_action_perform_login_pow_ajax');
        formData.append('login_nonce', await devtricker_ajax_get_devtricker_getDevtrickerLoginNonce());
        formData.append('pow', pow);
        formData.append('pass', pass);
        formData.append('duration', duration);

        const response = await fetch('/wp-admin/admin-ajax.php', {
            method: 'POST',
            credentials: 'same-origin',
            body: formData
        });

        const result = await response.json();

        if (result.success) {

            devtricker_log(null, devtricker_log_level.INFO, "Login successful");

        } else {
            throw new Error('Incorrect email or password');
        }

    } catch (error) {

        devtricker_log(error, devtricker_log_level.ERROR);

        throw error;
    }
}

async function simulateBruteForceLogin(form, attempts) {
    let successfulAttempts = 0;
    let attemptCount = 0;
    const startTime = performance.now();

    for (let i = 0; i < attempts; i++) {
        try {
            await devtricker_ajax_post_customWpLogin(form);
            successfulAttempts++;
            console.log(`Attempt ${i + 1}: Login successful`);
        } catch (error) {
            console.log(`Attempt ${i + 1}: Login failed - ${error.message}`);
        } finally {
            attemptCount++;
        }
    }

    const endTime = performance.now();
    const timeTaken = (endTime - startTime) / 1000;

    console.log(`Total attempts: ${attemptCount}`);
    console.log(`Successful logins: ${successfulAttempts}`);
    console.log(`Total time taken: ${timeTaken.toFixed(2)} seconds`);
}